import { useCallback, useEffect, useState } from "react";

import { ApiError, apiFetch } from "@/lib/api-client";
import type { PageTemplate } from "@ease/page-builder";

export async function fetchTemplateRegistry(): Promise<PageTemplate[]> {
  const response = await apiFetch<{ data: { items: PageTemplate[] } }>("/crm/pages/templates");
  return response.data.items ?? [];
}

export function useTemplateRegistry() {
  const [templates, setTemplates] = useState<PageTemplate[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      setTemplates(await fetchTemplateRegistry());
    } catch (error) {
      setTemplates([]);
      setError(error instanceof ApiError ? error.message : "Failed to load template registry");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { templates, isLoading, error, refresh };
}
